import { EntityContainer } from '@prezi/common-components';
function createDefaultAsync(defaultValue) {
  return {
    initialized: false,
    loading: false,
    value: defaultValue,
    error: null
  };
}
const getInitialState = ({
  page,
  documentOid,
  userInfo,
  showReferralCopyAndCode
}) => ({
  page: page || 'unified',
  documentOid,
  document: createDefaultAsync(undefined),
  unifiedPrivacy: createDefaultAsync(undefined),
  unlistedLink: createDefaultAsync(undefined),
  userPermissions: createDefaultAsync(undefined),
  collaborators: createDefaultAsync(new EntityContainer()),
  organization: createDefaultAsync(undefined),
  contacts: createDefaultAsync(new EntityContainer()),
  viewlinks: createDefaultAsync(new EntityContainer()),
  featureSwitches: createDefaultAsync(undefined),
  folderCollaborators: createDefaultAsync(new EntityContainer()),
  foldersRestrictions: createDefaultAsync(new EntityContainer()),
  currentUser: userInfo,
  referral: createDefaultAsync(undefined),
  showReferralCopyAndCode: showReferralCopyAndCode || false
});
export default getInitialState;